import type { ReactElement } from 'react';
import { Route } from 'config';
import Banner from 'components/shared/Banner';

// Obsolete Code - No longer in use
const BannerButton = (
  <a
    className="c-button c-button--secondary"
    href={Route.GIVEAWAYS}
  >
    Share
  </a>
);

function GiveawaysBanner(): ReactElement {
  return (
    <Banner button={BannerButton}>
      <strong>Congrats!</strong>
      <br />
      You have earned a free box to share with a friend!&nbsp;
      Spread a little plant-based love today!
    </Banner>
  );
}

export default GiveawaysBanner;
